export default __webpack_public_path__ + "static/hiv-landscape-section-hero-40c5bf0fa8a79c9d53df29ee59db1362.png";